import BackButton from 'v2/components/BackButton';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';

import Icon from 'v2/components/Icon';
import ButtonBase from 'v2/components/UI/ButtonBase';

import useListFiles from './hooks/useListFiles';
import HashLoading from 'v2/components/UI/Loading/Hash';
import { formatToDDMMYYYY } from 'v2/resources/utils/formatDate';
import { convertSizeBytesToMB } from 'v2/resources/utils/convertSizes';
import ModalConfirmDelete from '../components/ModalConfirmDelete';
import { IFileByGetResponse } from 'v2/resources/services/files/types';

//TODO: REFACTOR IN UPDATE REACT
const ListFiles: React.FC = () => {
  const {
    files,
    isLoadingGetFiles,
    dataModalConfirmDelete,
    isLoadingDeleteFiles,

    handleDownloadDocument,
    handleNavigateEditFile,
    handleOpenModalConfirmDelete,
    handleCloseModalConfirmDelete,
    handleDeleteFile,
  } = useListFiles();

  const renderListOrEmpty = () => {
    if (files.length === 0) {
      return <Text color="#005f47">Nenhum arquivo encontrado.</Text>;
    }

    return files.map((file) => (
      <Box
        key={file.id}
        padding={10}
        borderBottom="1px solid #005F4720"
        flexDirection="column"
        gap={5}
      >
        <Box justifyContent="space-between" width="100%" alignItems="center">
          <Text fontSize={16} fontWeight={700} color="#005F47">
            {file.title}
          </Text>
          <Text fontSize={16} color="#005F47">
            Tamanho: {convertSizeBytesToMB(file.size)}
          </Text>
        </Box>

        <Text fontSize={14} color="#666">
          {file.description}
        </Text>

        <Box gap={10}>
          <Box
            background={'#00b95310'}
            padding={10}
            borderRadius={8}
            width={'fit-content'}
            gap={2}
            alignItems="center"
          >
            <Text color="#00b953" fontSize={12} fontWeight={500}>
              Criado em:
            </Text>
            <Text color="#00b953" fontSize={12} fontWeight={500}>
              {formatToDDMMYYYY(file.createdAt)}
            </Text>
          </Box>

          <Box
            background={'#002fff10'}
            padding={10}
            borderRadius={8}
            width={'fit-content'}
            gap={2}
            alignItems="center"
          >
            <Text color="#002fff" fontSize={12} fontWeight={500}>
              Categoria:
            </Text>
            <Text color="#002fff" fontSize={12} fontWeight={500}>
              {file.category}
            </Text>
          </Box>
        </Box>

        <Box margin={'10px 0'} justifyContent="space-between" width={'100%'}>
          <ButtonBase
            alignItems="center"
            justifyContent="center"
            gap={10}
            background={'#005F47'}
            borderRadius={8}
            padding={10}
            width={'100%'}
            maxWidth={200}
            onClick={() => handleDownloadDocument(file.url)}
          >
            <Icon iconName="CloudDownloadOutlined" htmlColor="#fafafa" />
            <Text fontSize={16} color="#fafafa" fontWeight={500}>
              Baixar
            </Text>
          </ButtonBase>

          <Box gap={20}>
            <ButtonBase
              alignItems="center"
              justifyContent="center"
              gap={10}
              background={'#ffa60010'}
              borderRadius={8}
              padding={10}
              width={'100%'}
              maxWidth={200}
              onClick={() => handleNavigateEditFile(file, files.indexOf(file))}
            >
              <Icon iconName="BorderColorOutlined" htmlColor="#ffa600" />
            </ButtonBase>

            <ButtonBase
              alignItems="center"
              justifyContent="center"
              gap={10}
              background={'#f0000010'}
              borderRadius={8}
              padding={10}
              width={'100%'}
              maxWidth={200}
              onClick={() => handleOpenModalConfirmDelete(file)}
            >
              <Icon iconName="DeleteOutline" htmlColor="#f00" />
            </ButtonBase>
          </Box>
        </Box>
      </Box>
    ));
  };

  const renderLoadingOrList = () => {
    if (isLoadingGetFiles) {
      return (
        <Box alignItems="center" justifyContent="center" padding={50}>
          <HashLoading />
        </Box>
      );
    }

    return renderListOrEmpty();
  };

  return (
    <Box flexDirection="column" gap={30} padding={10}>
      <BackButton title="Voltar" />
      <Box flexDirection="column" gap={15}>
        <Text fontSize={22} fontWeight={700} color="#005F47">
          Lista de Arquivos
        </Text>

        <Box
          background="#fff"
          borderRadius={12}
          padding={15}
          width="100%"
          gap={15}
          flexDirection="column"
        >
          {renderLoadingOrList()}
        </Box>
      </Box>

      <ModalConfirmDelete
        file={dataModalConfirmDelete ?? ({} as IFileByGetResponse)}
        isOpen={!!dataModalConfirmDelete}
        isLoadingDeleteFiles={isLoadingDeleteFiles}
        onClose={handleCloseModalConfirmDelete}
        onDelete={handleDeleteFile}
      />
    </Box>
  );
};

export default ListFiles;
